export const iconFontAwesomeFilmVideoTowerCell = (
	<i className="fa-solid fa-tower-cell"></i>
);
